import { get, isNil } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { CLAIM_STATUS } from 'containers/data-structure';
export const isAssignedExpert = (mission: any, sagis_code: string) => {
  return (
    mission &&
    sagis_code &&
    get(mission, 'assignedExperts', [])
      .map((element: any) => element.expertCode)
      .includes(sagis_code)
  );
};
export const renderSearchQuery = (claimRecap: any) => {
  if (
    get(claimRecap, 'claim.status', '') === CLAIM_STATUS.VALIDATED &&
    featureService.hasFeature(FEATURES.SEARCH_BY_CLAIM_NUMBER)
  ) {
    return {
      claimNumber: get(claimRecap, 'claim.claimNumber', null),
      withDocuments: 'Y',
    };
  }
  if (
    (get(claimRecap, 'claim.status', '') === CLAIM_STATUS.PENDING ||
      get(claimRecap, 'claim.status', '') ===
        CLAIM_STATUS.PENDING_INFO_MODIFICATION) &&
    !isNil(get(claimRecap, 'claim.claimNumber', ''))
  ) {
    return {
      claimNumber: get(claimRecap, 'claim.claimNumber', null),
    };
  } else {
    return {
      lossDate: get(claimRecap, 'claim.lossDate', null),
      registrationNumber: get(claimRecap, 'claim.registrationNumber', null),
      policyNumber: get(claimRecap, 'claim.policyNumber', null),
    };
  }
};

export const renderMissionId = (missionId: string) => {
  if (missionId.includes('?')) {
    return get(missionId.split('?'), '[0]');
  } else {
    return missionId;
  }
};
